module.exports = __webpack_public_path__ + "img/woodenCase.b4a98845.jpg";